import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@common/components/Tooltip';
import { Badge } from '@components/Badge';
import { ErrorIcon } from '@components/Icon';

type Props = {
  text: string;
  description?: string;
  disabled?: boolean;
};

export const FieldLabel = ({ text, description, disabled = false }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-xsm">
        <label
          className={clsx(
            'text-md font-medium cursor-pointer leading-md',
            disabled && 'opacity-60'
          )}
        >
          <span className="mr-3 inline-block">
            <Badge tone="promo">{t('adBadge.plusOrMax')}</Badge>
          </span>
          {text}
          {description && (
            <span className="ml-3 inline-block align-middle relative">
              <Tooltip content={description} width={'w-[112px] md:w-[288px]'}>
                <ErrorIcon tone="success" size="small" variant="outline" />
              </Tooltip>
            </span>
          )}
        </label>
      </div>
    </>
  );
};
